module.exports = __webpack_public_path__ + "734601da459920aaa3781c0dd7b98770.png";